import { render, staticRenderFns } from "./dealerOrder.vue?vue&type=template&id=d42900b2&scoped=true&"
import script from "./dealerOrder.vue?vue&type=script&lang=js&"
export * from "./dealerOrder.vue?vue&type=script&lang=js&"
import style0 from "./dealerOrder.vue?vue&type=style&index=0&id=d42900b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d42900b2",
  null
  
)

export default component.exports